// Copyright (c) StrangeBee 2023

import { Route as GlobalTaskList } from './List';

export const Routes = [GlobalTaskList];
